module.exports = __webpack_public_path__ + "static/media/pinc-rect.80370dfa.png";